function MobileNav(global) {

  //Elements
  this.globalObj = global;
  this.wrap = document.getElementById("mobileNav");
  this.toggler = document.getElementById("mobileNavToggler");
  this.togglerSubMenu = document.getElementById("mobileNavTogglerSubMenu");
  this.mobileWrap = document.getElementById("mobileMenuWrap");
  this.mainContent = document.getElementById("PageContainer");
  this.subMenuList = $("#mobileMenuWrap .sub-list"); //List of all sub menus in the nav
  this.subMenuListToggle = $("#mobileMenuWrap .sub-list-toggle"); //List of all the toggle dom elements the user clicks to show and hide sub menus in the nav. Event listeners waiting for user input attached to these.

  //Vars
  this.active = false;

  $(this.togglerSubMenu).bind("click", function(e){
    if ( window.innerWidth < 1025 ) {
      e.preventDefault();
    }
  });
}

MobileNav.prototype.toggle = function(element) {

  "use strict"
  console.log(element);

  if (this.active == false) {
    this.active = true;
    $(element).addClass("active");
  } else {
    this.active = false;
    $(element).removeClass("active");
  }

}


MobileNav.prototype.stick = function() {

  "use strict"

  //Get position of nav
  var offsetNavObj = $(this.wrap).offset(); //jQuery offset function returns object with name values top and left, we only want the 'top' value
  var pageLoadOffsetNav = offsetNavObj.top;
  var currentOffsetNav = pageLoadOffsetNav;

  //Get position of window
  var scrollPos = this.globalObj.scrollY;

  //Check that window's position is more than navs on scroll
  if (scrollPos > pageLoadOffsetNav){
    console.log("Sticking to top. Maybe fix element?");
  }
  //if true
    //set nav's position to window

}